module.exports = __webpack_public_path__ + "img/fondo-login-min.87c92170.png";